// 防抖函数
function debounce(fn, delay) {
    let timer
    return function() {
      clearTimeout(timer)
      timer = setTimeout(() => fn.apply(this, arguments), delay)
    }
  }
  
  // 设置根字体
  function setRem() {
    const designWidth = 1920 // 设计稿宽度
    const baseSize = designWidth / 10 // 1rem基准值（192px）
    const currentWidth = document.documentElement.clientWidth
    
    // 限制最大缩放比例（可选）
    const maxScale = 2
    const scale = Math.min(currentWidth / designWidth, maxScale)
    
    document.documentElement.style.fontSize = baseSize * scale + 'px'
  }
  
  // 初始化执行
  setRem()
  
  // 监听事件
  const optimizedRem = debounce(setRem, 100)
  window.addEventListener('resize', optimizedRem)
  window.addEventListener('orientationchange', optimizedRem)
  
  // 添加视觉视口监听（解决缩放问题）
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', optimizedRem)
  }
  
  // 兼容Safari缩放
  window.onpageshow = (event) => {
    if (event.persisted) setRem()
  }